import { LevelUpContextInitialState } from '.';
import { LEVELUP_ACTIONS } from './actions';

export const levelUpContextReducer = (state = LevelUpContextInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LEVELUP_ACTIONS.SET_LEVEL_UP_DETAILS: {
      return {
        ...state,
        levelUpDetails: payload,
      };
    }
    case LEVELUP_ACTIONS.SET_IS_MANAGER_FLAG: {
      return {
        ...state,
        isLoggedInEmployeeManager: payload,
      };
    }

    case LEVELUP_ACTIONS.UPDATE_COMPETENCY_TARGET_DATE: {
      const { jobFunctionId, jobRoleId, competencyId, subCompetencyId, targetPeriodStart } = payload;

      /* TODO: handle sub competency date change */
      const updatedJobCompetencies = state.levelUpDetails.tableData.competencies.map((jCObj) => {
        if (jCObj.competencyId === competencyId) {
          return {
            ...jCObj,
            targetPeriodStart,
          };
        }
        return jCObj;
      });

      return {
        ...state,
        levelUpDetails: {
          ...state.levelUpDetails,
          tableData: {
            ...state.levelUpDetails.tableData,
            competencies: updatedJobCompetencies,
          },
        },
      };
    }

    case LEVELUP_ACTIONS.UPDATE_COMPETENCY_PROGRESS_STATUS: {
      const { jobFunctionId, jobRoleId, competencyId, subCompetencyId, status } = payload;

      const updatedJobCompetencies = state.levelUpDetails.jobCompetencies.map((jCObj) => {
        if (jCObj.jobFunction.uuid === jobFunctionId && jCObj.jobRole.uuid === jobRoleId) {
          return {
            ...jCObj,
            competencies: jCObj.competencies.map((cObj) => {
              if (cObj.competencyId === competencyId) {
                return {
                  ...cObj,
                  status,
                };
              }
              return cObj;
            }),
          };
        }
        return jCObj;
      });

      return {
        ...state,
        levelUpDetails: {
          ...state.levelUpDetails,
          jobCompetencies: updatedJobCompetencies,
        },
      };
    }

    case LEVELUP_ACTIONS.OPEN_ROLE_SELECTION_MODAL: {
      return {
        ...state,
        isRoleSelectionModalOpen: true,
        isNewRoleSelection: payload?.isNewRoleSelection ?? false,
      };
    }
    case LEVELUP_ACTIONS.CLOSE_ROLE_SELECTION_MODAL: {
      return {
        ...state,
        isRoleSelectionModalOpen: false,
      };
    }

    case LEVELUP_ACTIONS.SET_ONE_ON_ONE_INSTANCE_DETAILS: {
      return {
        ...state,
        checkInInstanceId: payload.checkInInstanceId,
        checkInParentId: payload.checkInParentId,
        filterEmpIds: payload.filterEmpIds,
      };
    }

    case LEVELUP_ACTIONS.CHANGE_SELECTED_ROLE: {
      return {
        ...state,
        isTargetRoleSelected: payload.isTargetRole,
      };
    }

    case LEVELUP_ACTIONS.SET_LEVEL_UP_TARGET_DATES: {
      return {
        ...state,
        levelUpTargetDates: payload,
      };
    }

    case LEVELUP_ACTIONS.TOGGLE_COMPETENCY_FILTER: {
      // single select
      // const modifiedCompetencyFilters = Object.keys(state.competencyFilters).reduce(
      //   (attrs, key) => ({
      //     ...attrs,
      //     [key]: false,
      //   }),
      //   {}
      // );
      // return {
      //   ...state,
      //   competencyFilters: {
      //     ...modifiedCompetencyFilters,
      //     [payload.filter]: !state.competencyFilters[payload.filter],
      //   },
      // };

      // commenting logic for multi select, it'll be there in v2
      return {
        ...state,
        competencyFilters: {
          ...state.competencyFilters,
          [payload.filter]: !state.competencyFilters[payload.filter],
        },
      };
    }

    case LEVELUP_ACTIONS.SET_ALL_COMPETENCY_FILTER: {
      // setting all the filters as false, which means ALL filter is applied
      const modifiedCompetencyFilters = Object.keys(state.competencyFilters).reduce(
        (attrs, key) => ({
          ...attrs,
          [key]: false,
        }),
        {}
      );

      return {
        ...state,
        competencyFilters: {
          ...state.competencyFilters,
          ...modifiedCompetencyFilters,
        },
      };
    }

    case LEVELUP_ACTIONS.SET_FILTERED_COMPETENCY_TABLE_DATA: {
      return {
        ...state,
        levelUpDetails: {
          ...state.levelUpDetails,
          tableData: {
            ...state.levelUpDetails.tableData,
            competencies: payload.competencies,
          },
        },
      };
    }

    case LEVELUP_ACTIONS.SET_LEVEL_UP_PROGRESS_STATUSES: {
      return {
        ...state,
        levelUpProgressStatuses: payload,
      };
    }

    case LEVELUP_ACTIONS.SET_LEVEL_UP_RISK_ESTIMATION_LIST: {
      return {
        ...state,
        riskEstimationList: payload,
      };
    }

    case LEVELUP_ACTIONS.SET_FUNCTION_AND_ROLE_NOT_SET: {
      return {
        ...state,
        functionAndRoleNotSet: payload.isSet,
      };
    }

    default:
      return state;
  }
};
